import {IMutableRulesetParams, MutableRuleset, template as tpl} from "./mutableRuleset";
import {ObjectTypeId} from "../../../constants";
import {global} from "../../../appContext";
import {MutableRule} from "./rule/MutableRule";
import {_} from 'lodash';
import {memoryStore} from "../../../util/memorystore";
import {IRule} from "../../../index";
import {convertToArray, createErrorMessage, getAnyValue, hasMultipleImportFormatTypes} from "../../../util/misc";
import {CREATING_MESSAGE, ERROR_MESSAGE, REQUEST_MESSAGE} from "../../../constants/Language";
import {nsDataSource} from "../../../util/nsDataSource";
import {trackSurvicateEvent} from "../../../util/survicate";

export let template: string = tpl;

export class viewModel extends MutableRuleset {

    protected override submitRequestMessage: string = CREATING_MESSAGE;
    protected override submitSuccessMessage: string = `subject is created|s:((ruleset))`;
    protected override submitErrorMessage: string = ERROR_MESSAGE;
    protected _data: any;

    constructor(params: IMutableRulesetParams, autoInit = true) {
        super(params);
        let paramsObjectTypeId: ObjectTypeId
        if (this.params.objectTypeId) {
            paramsObjectTypeId = convertToArray(getAnyValue(this.params.objectTypeId))[0] ?? ObjectTypeId.User
        } else {
            paramsObjectTypeId = this.__objectTypeId ?? ObjectTypeId.User
        }
        this.initialObjectTypeId = paramsObjectTypeId
        _.defaultsDeep(params, {autoInit: true});
        this.reqSubmit = global.getPromiseRequest("createruleset");
        this.data.companyid(global.login.selectedOrganizationId() ?? '');
        if (hasMultipleImportFormatTypes()) {
            const org = global.login.selectedOrganization();
            const importFormatType = org ? nsDataSource.getImportFormatType(org.importformat) : null;
            if (importFormatType) {
                this.data.$original.authdatasources = importFormatType;
                this.data.authdatasources(importFormatType);
            }
        }
        if (autoInit) {
            this.init();
        }
    }

    protected override init(): Promise<void> {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        this._data = memoryStore.get('routeData')();
        return super.init()
            .then(() => {
                this.initObjectTypes()
                this.initData();
                this.messageData(null);
                this.isReady(true);
            })
            .catch((reason: string) => this.messageData(createErrorMessage(String(reason))))
    }

    protected getPreviewParams(): any {
        const ruleset = _.cloneDeep(this.getSubmitData());
        ruleset.rules = this.data.rules().map((rule: MutableRule) => rule.toStatic());
        return {ruleset, routeDef: {showHeading: false}}
    }

    protected override initData() {
        super.initData();
        const d = this._data || {};

        const rules = d.rules ? d.rules.map((r: IRule, index: number) => {
            return new MutableRule(this.availableData, _.defaults({order: index + 1}, r));
        }) : [];
        const objecttype = this.objectTypes.find(o => o.id == this.initialObjectTypeId);
        const name = d.name || '';
        const description = d.description || '';

        this.data.rules(rules);
        this.data.objectType(objecttype ?? null);
        this.data.name(name);
        this.data.description(description);
        this.data.departmentexpression('')
        this.data.evaluatepositions(false)
    }

    public override onSubmit() {
        trackSurvicateEvent('ces.ruleset.create');
        super.onSubmit();
    }
}
